<template>
    <div class="table_wrap">
        <div class="input_error">※출금 진행하는 계좌의 예금주와 신청 예금주명이 다를 경우 출금 진행하지 않습니다.</div>
        <el-table :data="pointData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  height="675px"
                  @selection-change="tableSelectChange"
        >
            <el-table-column
                type="selection"
                class-name="text-center"
                min-width="25">
            </el-table-column>
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                width="90"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="결제번호" prop="p_uuid" width="150" class-name="text-center"></el-table-column>
            <el-table-column label="아이디" prop="mb_id" min-width="150" class-name="text-center"></el-table-column>
            <el-table-column label="출금요청금액(MG)" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnPoint(scope.row.p_point) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="출금요청금액(￦)" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnMoney(scope.row.p_point) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="예금주" class-name="text-center" prop="ma_name"></el-table-column>
            <el-table-column label="은행" class-name="text-center" prop="ma_bank"></el-table-column>
            <el-table-column label="계좌번호" class-name="text-center" prop="ma_account"></el-table-column>
            <el-table-column label="출금요청일" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.created_at }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="옵션" width="180" class-name="text-center">
                <template slot-scope="scope">
                    <div v-if="returnStatus(scope.row.pw_status) === false">
                        <el-button class="com_btn" @click="withdrawFunc('approve',scope.row.p_idx)">출금완료</el-button>
                        <el-button class="com_del" @click="withdrawFunc('deny',scope.row.p_idx)">출금취소</el-button>
                    </div>
                    <div v-else>
                        {{ returnStatus(scope.row.pw_status) }}
                    </div>
                </template>
            </el-table-column>
        </el-table>

    </div>

</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import priceMixins from "@/mixins/priceMixins";

export default {
    name: "PointListWithdrawLayout",
    mixins: [dateMixins, alertMixins, priceMixins,],
    components: {},
    inject: ['setPage', 'setFilter', 'setPointListData'],
    provide() {
        return {}
    },
    props: {
        pointType: '',
        pointData: {
            default: () => {
                return []
            }
        },
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
    },
    data() {
        return {
            selectArr: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        returnDate(date = null) {
            if (!date) {
                return '';
            }
            return this.$moment(date).format('YYYY-MM-DD HH:mm')
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        returnPoint(point) {
            point = Math.abs(point);
            point = util.Number.numFormat(point);
            return point;
        },
        returnMoney(point) {
            point = Math.abs(point) * 10;
            point = util.Number.numFormat(point);
            return point;
        },
        tableSelectChange(row) {
            this.selectArr = [];
            util.Array.each(row, (obj, index, arr) => {
                this.selectArr.push(obj.p_idx);
            });
            this.setPointListData('selectArr', this.selectArr)
        },
        returnStatus(status) {
            switch (status) {
                case 0 : {
                    return false
                }
                case 2 : {
                    return '출금완료'
                }
                case 3 : {
                    return '출금취소'
                }
                default : {
                    return '-'
                }
            }
        },
        withdrawFunc(type, idx) {
            this.parentChange('selectArr', [idx])
            EventBus.$emit(`${type}Withdraw`)
        },
        parentChange(key, value) {
            this.setPointListData(key, value)
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
